import { createAction, props } from '@ngrx/store';

export const loadLocationsApi = createAction(
  '[Locations Component API] Load Locations'
);

export const loadLocationsSuccess = createAction(
  '[Locations Component] Load Locations Success',
  props<{ locations: any[] | null }>()
);

export const loadLocationsFailure = createAction(
  '[Locations Component] Load Locations Failure',
  props<{ error: any }>()
);

export const selectLocationsFilter = createAction(
  '[Locations Component API] Select Locations Filter',
  props<{ selectedLocationsFilter: string }>()
);

